import { ListType } from '../../src/constants/enums'
import type { ActiveLists } from '../../types'

export const PERMANENT_ACTIVE_LISTS: ActiveLists = {
    [ListType.ALERTS]: true,
    [ListType.BOOKMARKS]: true,
    [ListType.DEFAULT]: true,
    [ListType.DEFAULT_PUBLIC]: true,
    [ListType.FRIENDS]: true,
    [ListType.LAST_VIEWED]: true,
    [ListType.SEARCH]: true,
    [ListType.POPULAR]: true,
}

export const ACTIVE_LISTS: ActiveLists = {
    ...PERMANENT_ACTIVE_LISTS,
}
